import { sanitizeEmailHtml } from './sanitizeEmailHtml';

function escapeHtml(s: string): string {
  return s
    .replace(/&/g, '&amp;')
    .replace(/</g, '&lt;')
    .replace(/>/g, '&gt;')
    .replace(/"/g, '&quot;')
    .replace(/'/g, '&#039;');
}

/**
 * A sandboxed-iframe document for a stored email: the sanitized `bodyHtml`, or
 * the plain `body` when there is no HTML. Emails are designed for a white
 * canvas, so the frame stays light regardless of the app theme (forcing dark
 * inverted text but left email-built containers white). `padding` and
 * `fontSize` set the body's CSS padding and base text size.
 */
export function emailSrcDoc(
  bodyHtml: string | null | undefined,
  body: string | null | undefined,
  padding = '16px 18px',
  fontSize = '14px',
): string {
  if (!bodyHtml && !body) return '';
  const inner = bodyHtml
    ? sanitizeEmailHtml(bodyHtml)
    : `<pre style="font-family: ui-sans-serif, system-ui, sans-serif; white-space: pre-wrap; word-wrap: break-word; margin: 0;">${escapeHtml(
        body || '',
      )}</pre>`;
  return `<!doctype html>
<html><head><meta charset="utf-8"><base target="_blank">
<style>
  html, body { margin: 0; padding: 0; color-scheme: light; }
  body {
    font-family: -apple-system, BlinkMacSystemFont, "Segoe UI", Helvetica, Arial, sans-serif;
    color: #1f2937;
    background: #ffffff;
    padding: ${padding};
    line-height: 1.5;
    font-size: ${fontSize};
  }
  pre { color: #1f2937; }
  a { color: inherit; text-decoration: underline; pointer-events: none; }
  img { max-width: 100%; height: auto; }
  table { border-collapse: collapse; max-width: 100%; }

  /* Match the app-wide .scrollbar-custom styling so the iframe doesn't
     surface a default-chrome browser scrollbar. */
  html { scrollbar-gutter: stable; }
  ::-webkit-scrollbar { width: 0.55rem; height: 0.55rem; }
  ::-webkit-scrollbar-track { background: transparent; }
  ::-webkit-scrollbar-thumb {
    background: rgba(0, 0, 0, 0.25);
    border-radius: 9999px;
    border: 2px solid transparent;
    background-clip: content-box;
  }
  ::-webkit-scrollbar-thumb:hover {
    background: rgba(0, 0, 0, 0.45);
    background-clip: content-box;
  }
</style>
</head><body>${inner}</body></html>`;
}
